export enum TireStatus {
  NULL = 'NULL',

  STOCK = 'STOCK',

  RECAP = 'RECAP',

  WASTE = 'WASTE',

  INSTALLED = 'INSTALLED',

  STEPPE = 'STEPPE',

  REPLACEMENT = 'REPLACEMENT',

  GROOVE = 'GROOVE',

  ROTATION = 'ROTATION',

  MAINTENANCE = 'MAINTENANCE',
}
